import React from 'react'
import PropTypes from 'prop-types'
import { makeT } from '../../group_leader/helpers/i18n'

const t = makeT('group_leader.event_results.instruction')

// What happens next; the copy carries <strong>, so it is set as HTML from our own locale strings (REACT-074).
const SHARE_STEP = 'step_share_html'
const ENTER_SCORES_STEP = 'step_enter_scores_html'
const AFTER_STEPS = [ 'step_updates_html', 'step_finalize_html' ]

const InstructionStep = ({ number, textKey }) => (
  <li className="gl-event-results-instruction-step">
    <span className="gl-event-results-step-num" aria-hidden="true">{number}</span>
    <span
      className="gl-event-results-instruction-step-text"
      dangerouslySetInnerHTML={{ __html: t(textKey) }}
      />
  </li>
)

InstructionStep.propTypes = {
  number: PropTypes.number.isRequired,
  textKey: PropTypes.string.isRequired,
}

const InstructionSteps = ({ hasScoreEntry, hasScoringLinks = true }) => {
  // Numbered as shown; the share step goes with the header button when no group is pinned.
  const stepKeys = [
    ...(hasScoringLinks ? [ SHARE_STEP ] : []),
    ...(hasScoreEntry ? [ ENTER_SCORES_STEP ] : []),
    ...AFTER_STEPS,
  ]

  return (
    <div
      className="gl-event-results-instruction-banner"
      role="note"
      aria-label={t('banner_aria')}
      >
      <h2 className="gl-event-results-instruction-title">{t('title')}</h2>
      <ol className="gl-event-results-instruction-steps">
        {stepKeys.map((textKey, index) => (
          <InstructionStep key={textKey} number={index + 1} textKey={textKey}/>
        ))}
      </ol>
    </div>
  )
}

InstructionSteps.propTypes = {
  hasScoreEntry: PropTypes.bool,
  // False when no group is pinned yet, so there is no scoring link to share.
  hasScoringLinks: PropTypes.bool,
}

export default InstructionSteps
